import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { assetData } from "../../general/asset/fragments";
import { policyData } from "./fragments";
import { insuranceData } from "features/insuranceDocument/queries/fragments";
import Fragments from "features/insuranceDocument/edit/general/partner/fragments";

export const POLICY_GENERATED = gql`
  subscription policyGenerated($documentId: Int!) {
    policyGenerated(documentId: $documentId) {
      policyData {
        ...policyData
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${policyData}
  ${messageHeaders}
`;

export const POLICY_FILES_UPLOADED = gql`
  subscription policyFileUploaded {
    policyFileUploaded {
      policyData {
        ...policyData
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${policyData}
  ${messageHeaders}
`;

export const OFFER_DATA_SAVED = gql`
  subscription offerDataSaved($documentId: Int!) {
    offerDataSaved(documentId: $documentId) {
      documentId
      insuranceData {
        ...insuranceData
      }
      asset {
        ...assetData
      }
      insured {
        ...partnerData
      }
      client {
        ...partnerData
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
  ${insuranceData}
  ${assetData}
  ${Fragments.partnerData}
`;
